import { createContext, useContext, useMemo, useState } from 'react';

const ViewModeContext = createContext(null);
const STORAGE_KEY = 'sentinel-command:view-mode';

export function ViewModeProvider({ children }) {
  const [mode, setModeState] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === 'technical' ? 'technical' : 'executive';
    } catch {
      return 'executive';
    }
  });

  const value = useMemo(() => ({
    mode,
    isExecutive: mode === 'executive',
    setMode: next => {
      const safe = next === 'technical' ? 'technical' : 'executive';
      try { localStorage.setItem(STORAGE_KEY, safe); } catch { /* ignore */ }
      setModeState(safe);
    },
  }), [mode]);

  return <ViewModeContext.Provider value={value}>{children}</ViewModeContext.Provider>;
}

export function useViewMode() {
  const ctx = useContext(ViewModeContext);
  if (!ctx) throw new Error('useViewMode must be used within ViewModeProvider');
  return ctx;
}
